/** @deprecated Import from @hyperframes/parsers/sub-composition-validity */
export * from "@hyperframes/parsers/sub-composition-validity";
